'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const button_types = require('../Button/button.types.js');
const buttonGroup = require('../ButtonGroup/buttonGroup.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["name", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var fixTabName = function fixTabName(name) {
  return name.replace(/ /g, '_').toLowerCase();
};
var Context = /*#__PURE__*/React.createContext(null);
var TabsContext = function TabsContext(_ref) {
  var _ref$initialActiveTab = _ref.initialActiveTab,
    initialActiveTab = _ref$initialActiveTab === void 0 ? '' : _ref$initialActiveTab,
    children = _ref.children;
  var _useState = React.useState(initialActiveTab),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var tabProviderValue = {
    activeTab: activeTab,
    setActiveTab: setActiveTab
  };
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: tabProviderValue
  }, children);
};
var useTabsContext = function useTabsContext() {
  var context = React.useContext(Context);
  if (context === null) {
    throw new Error('useTabsContext must be used within a TabsContext Provider');
  }
  return context;
};
var ButtonGroup = styled__default(buttonGroup.default).withConfig({
  displayName: "tabs__ButtonGroup",
  componentId: "sc-gzp28w-0"
})(["padding-bottom:12px;"]);
var DEFAULT_DATA_ATTR = {
  'data-testid': 'tab-list'
};
var TabList = function TabList(_ref2) {
  var _ref2$buttonProps = _ref2.buttonProps,
    buttonProps = _ref2$buttonProps === void 0 ? {} : _ref2$buttonProps,
    _ref2$buttonSize = _ref2.buttonSize,
    buttonSize = _ref2$buttonSize === void 0 ? button_types.ButtonSizes.MEDIUM : _ref2$buttonSize,
    buttonWrapperProps = _ref2.buttonWrapperProps,
    _ref2$dataAttr = _ref2.dataAttr,
    dataAttr = _ref2$dataAttr === void 0 ? {} : _ref2$dataAttr,
    _ref2$list = _ref2.list,
    list = _ref2$list === void 0 ? [] : _ref2$list;
  var tabContext = useTabsContext();
  var tabs = list.map(function (tabProps, i) {
    var _tabProps$dataAttr;
    var DEFAULT_DATA_ATTR = {
      'data-testid': "tab-button--".concat(i)
    };
    var combinedDataAttr = _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR), (_tabProps$dataAttr = tabProps.dataAttr) !== null && _tabProps$dataAttr !== void 0 ? _tabProps$dataAttr : {});
    var handlers = _objectSpread(_objectSpread({}, tabProps.handlers), {}, {
      onClick: function onClick(event) {
        var _tabProps$handlers;
        tabContext === null || tabContext === void 0 || tabContext.setActiveTab(tabProps.name);
        if ((_tabProps$handlers = tabProps.handlers) !== null && _tabProps$handlers !== void 0 && _tabProps$handlers.onClick) {
          tabProps.handlers.onClick(event);
        }
      }
    });
    return _objectSpread(_objectSpread({}, tabProps), {}, {
      dataAttr: combinedDataAttr,
      handlers: handlers,
      hasHover: false,
      key: tabProps.name,
      label: tabProps.name,
      shape: button_types.ButtonShapes.TAB,
      size: buttonSize
    }, buttonProps);
  });
  var activeTabIndex = list.findIndex(function (tab) {
    return tab.name === (tabContext === null || tabContext === void 0 ? void 0 : tabContext.activeTab);
  });
  var combinedDataAttr = _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR), dataAttr);
  return /*#__PURE__*/React__default.createElement(ButtonGroup, {
    data: tabs,
    dataAttr: combinedDataAttr,
    buttonWrapperProps: buttonWrapperProps,
    selected: activeTabIndex,
    selectedStyleName: button_types.ButtonStyles.SELECTED_TAB
  });
};
var TabPanel = function TabPanel(_ref3) {
  var _ref3$name = _ref3.name,
    name = _ref3$name === void 0 ? '' : _ref3$name,
    children = _ref3.children,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var tabContext = useTabsContext();
  return (tabContext && tabContext.activeTab) === name ? /*#__PURE__*/React__default.createElement("div", _extends({
    id: "tabpanel_".concat(fixTabName(name)),
    "aria-labelledby": "tab_".concat(fixTabName(name))
  }, restProps), children) : null;
};
var Tabs = function Tabs(_ref4) {
  var _ref4$buttonProps = _ref4.buttonProps,
    buttonProps = _ref4$buttonProps === void 0 ? {} : _ref4$buttonProps,
    _ref4$buttonSize = _ref4.buttonSize,
    buttonSize = _ref4$buttonSize === void 0 ? button_types.ButtonSizes.MEDIUM : _ref4$buttonSize,
    buttonWrapperProps = _ref4.buttonWrapperProps,
    _ref4$initialActiveTa = _ref4.initialActiveTab,
    initialActiveTab = _ref4$initialActiveTa === void 0 ? '' : _ref4$initialActiveTa,
    _ref4$list = _ref4.list,
    list = _ref4$list === void 0 ? [] : _ref4$list,
    listDataAttr = _ref4.listDataAttr;
  return /*#__PURE__*/React__default.createElement(TabsContext, {
    initialActiveTab: initialActiveTab
  }, /*#__PURE__*/React__default.createElement(TabList, {
    buttonProps: buttonProps,
    buttonSize: buttonSize,
    buttonWrapperProps: buttonWrapperProps,
    dataAttr: listDataAttr,
    list: list
  }), list.map(function (tab) {
    return /*#__PURE__*/React__default.createElement(TabPanel, {
      key: tab.name,
      name: tab.name
    }, tab.children);
  }));
};

exports.TabList = TabList;
exports.TabPanel = TabPanel;
exports.Tabs = Tabs;
exports.TabsContext = TabsContext;
exports.useTabsContext = useTabsContext;
